export default __webpack_public_path__ + "static/media/SingHealth_Logo.33adc4c8.png";